import { create } from 'zustand';
import { api } from '../services/api';

export const useChatsStore = create((set, get) => ({
  chats: [],
  total: 0,
  limit: 50,
  offset: 0,
  currentChat: null,
  isLoading: false,
  error: null,
  userId: null, // Фильтр по пользователю

  // Загрузка чатов
  fetchChats: async (params = {}) => {
    set({ isLoading: true, error: null });
    try {
      const queryParams = {
        limit: params.limit || get().limit,
        offset: params.offset || 0,
      };

      // Добавляем фильтр по пользователю если указан
      const userId = params.user_id !== undefined ? params.user_id : get().userId;
      if (userId) {
        queryParams.user_id = userId;
      }

      const data = await api.getChats(queryParams);
      set({
        chats: data.chats || [],
        total: data.total || 0,
        limit: data.limit || get().limit,
        offset: data.offset || 0,
        userId: userId,
        isLoading: false,
      });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false, chats: [] });
      return null;
    }
  },

  // Сбросить фильтр по пользователю
  clearUserIdFilter: () => {
    set({ userId: null });
  },

  // Загрузка одного чата с сообщениями
  fetchChat: async (id) => {
    set({ isLoading: true, error: null, currentChat: null });
    try {
      const chat = await api.getChat(id);
      set({ currentChat: chat, isLoading: false });
      return chat;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Удалить чат
  deleteChat: async (id) => {
    try {
      await api.deleteChat(id);
      get().fetchChats();
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Очистка текущего чата
  clearCurrentChat: () => {
    set({ currentChat: null });
  },

  // Очистка
  clear: () => {
    set({ chats: [], total: 0, currentChat: null, error: null });
  },

  // Сброс ошибки
  clearError: () => {
    set({ error: null });
  },
}));
